import { render, staticRenderFns } from "./CompanyShow.vue?vue&type=template&id=549cb76e&"
import script from "./CompanyShow.vue?vue&type=script&lang=ts&"
export * from "./CompanyShow.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports